define(["exports", "./pubsubhub", "./utils"], function (_exports, _pubsubhub, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.default = _exports.name = void 0;

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const name = "core/linter";
  /** @type {WeakMap<Linter, { rules: Set<import("./LinterRule").default> }>} */

  _exports.name = name;
  const privates = new WeakMap();

  class Linter {
    constructor() {
      privates.set(this, {
        rules: new Set()
      });
    }

    get rules() {
      return privates.get(this).rules;
    }
    /**
     * @param  {...import("./LinterRule").default} newRules
     */


    register(...newRules) {
      newRules.forEach(newRule => this.rules.add(newRule));
    }

    async lint(conf, doc = window.document) {
      const promisesToLint = [...privates.get(this).rules].map(rule => toLinterWarning(rule.lint(conf, doc)));
      await promisesToLint;
    }

  }

  const linter = new Linter();
  var _default = linter;
  _exports.default = _default;
  const baseResult = {
    name: "unknown",
    description: "",
    occurrences: 0,
    howToFix: "",
    offendingElements: [],
    // DOM Nodes
    help: "" // where to get help

  };
  /**
   * @typedef {import("./LinterRule").LinterResult} LinterResult
   * @param {LinterResult | Promise<LinterResult>} [resultPromise]
   */

  async function toLinterWarning(resultPromise) {
    const result = await resultPromise;

    if (!result) {
      return;
    }

    const output = _objectSpread({}, baseResult, {}, result);

    const {
      description,
      help,
      howToFix,
      name,
      occurrences,
      offendingElements
    } = output;
    const message = "Linter (".concat(name, "): ").concat(description, " ").concat(howToFix, " ").concat(help);

    if (offendingElements.length) {
      (0, _utils.showInlineWarning)(offendingElements, "".concat(message, " Occured"));
    } else {
      (0, _pubsubhub.pub)("warn", "".concat(message, " (Count: ").concat(occurrences, ")"));
    }
  }

  function run(conf) {
    if (conf.lint === false) {
      return; // nothing to do
    } // return early, continue processing other things


    (async () => {
      await document.respecIsReady;

      try {
        await linter.lint(conf, document);
      } catch (err) {
        console.error("Error ocurred while running the linter", err);
      }
    })();
  }
});
//# sourceMappingURL=linter.js.map